import * as _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  data: null,
  error: false,
  loading: false,
  taxRateSites: [],
  taxRate: null,
  taxRateSaveSitesSuccessful: false,
  taxRateSaveSuccessful: false,
  getSitesError: null,
  saveSitesError: null,
  getTaxRateError: null,
  deleteSuccessful: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TAXRATE_GET: {
      if (_.has(action.payload, 'data.Data')) {
        return {
          ...state,
          data: action.payload.data.Data,
        };
      } else {
        return state;
      }
    }
    case types.TAXRATE_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.TAXRATE_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case types.TAX_RATE_SETUP_GET_SITES:
      return { ...state, taxRateSites: action.payload };
    case types.TAX_RATE_SETUP_SAVE_SITES_SUCCESSFUL:
      return { ...state, taxRateSaveSitesSuccessful: action.payload };
    case types.TAX_RATE_SETUP_GET_TAX_RATES:
      return { ...state, taxRate: action.payload };
    case types.TAX_RATE_SETUP_GET_SITES_ERROR:
      return { ...state, getSitesError: action.payload };
    case types.TAX_RATE_SETUP_SAVE_SITES_ERROR:
      return { ...state, getSitesError: action.payload };
    case types.TAX_RATE_SETUP_GET_TAX_RATES_ERROR:
      return { ...state, getTaxRateError: action.payload };
    case types.TAX_RATE_SETUP_CLEAR_ERRORS:
      return { ...state, getSitesError: null, saveSitesError: null };
    case types.TAX_RATE_SETUP_SAVE_SUCCESSFUL:
      return { ...state, taxRateSaveSuccessful: action.payload };
    case types.TAX_RATE_SETUP_SAVE_DELETE_SUCCESSFUL:
      return { ...state, deleteSuccessful: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/taxRates/reducer.js